import axios from "axios";
import { apiVariable } from "./apiVariable";

export interface ExchangeRateDto {
  id: string;
  year: number;
  month: number;
  sourceCurrency: string;
  targetCurrency: string;
  rate: number;
}

export const exchangeRateService = {
  getAll: (headers: Record<string, string>) =>
    axios.get<ExchangeRateDto[]>(`${apiVariable}/exchange-rates`, { headers }),
  lookup: (
    year: number,
    month: number,
    sourceCurrency: string,
    targetCurrency: string,
    headers: Record<string, string>,
    signal?: AbortSignal,
  ) =>
    axios.get<ExchangeRateDto | undefined>(
      `${apiVariable}/exchange-rates/lookup`,
      {
        headers,
        params: { year, month, sourceCurrency, targetCurrency },
        signal,
      },
    ),
  create: (
    rate: Omit<ExchangeRateDto, "id">,
    headers: Record<string, string>,
  ) =>
    axios.post<ExchangeRateDto>(`${apiVariable}/exchange-rates`, rate, {
      headers,
    }),
  update: (rate: ExchangeRateDto, headers: Record<string, string>) =>
    axios.put<ExchangeRateDto>(`${apiVariable}/exchange-rates`, rate, {
      headers,
    }),
  delete: (id: string, headers: Record<string, string>) =>
    axios.delete(`${apiVariable}/exchange-rates/${id}`, { headers }),
};
